import React from 'react';
import { sendApiRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';
import { handle400Statuses } from '@services/api';
import styled from 'styled-components';
import { FormStateContext } from '@/contexts/FormStateContext';

const Select = styled.select`
  width: 100%;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};
  border-radius: 4px;
  padding: 0 8px;
`;

export const AgentSelectInput = (props) => {
  const { state: formState, setFormStateValue } = React.useContext(FormStateContext);
  const { agentName: value } = formState;

  const [agents, setAgents] = React.useState(null);

  const handleChange = (e) => {
    const {
      target: { value },
    } = e;
    setFormStateValue('agentName', value);
  };

  React.useEffect(() => {
    const getAllAgents = async () => {
      const URL = `v1/genai_agent_script_definitions`;
      const { status, data } = await sendApiRequest('get', URL);
      logNetRequest(status, data);
      handle400Statuses(status);
      if (status === 200) {
        setAgents(data.sort((a, b) => a.script_name.localeCompare(b.script_name)));
        return true;
      } else {
        return false;
      }
    };

    getAllAgents();
  }, []);

  if (!agents) {
    return (
      <Select onChange={() => null} value={'Loading...'}>
        <option value={'Loading...'}>Loading...</option>
      </Select>
    );
  }

  return (
    <Select onChange={handleChange} value={value}>
      <option value={''}>Select Agent...</option>
      {agents.map((agent) => (
        <option key={agent.id} value={agent.script_name}>
          {agent.script_name}
        </option>
      ))}
    </Select>
  );
};
